import React, { ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';

import {
  widgetPaths,
  widgetSearchParamKeys,
} from '~/views/widgets/widget-utils';

import * as S from './IndicatorWrapper.styles';

interface SingleWidgetProps {
  headerElement: ReactNode;
  contentElement: ReactNode;
  indicator: string;
}

export const IndicatorWrapper = ({
  headerElement,
  contentElement,
  indicator,
}: SingleWidgetProps) => {
  const [, setSearchParams] = useSearchParams();
  return (
    <S.WidgetSection
      aria-labelledby="widget-section"
      onClick={() =>
        setSearchParams({
          widget: widgetPaths.indicatorTadpole,
          [widgetSearchParamKeys.indicator]: indicator,
        })
      }
    >
      <S.Header>{headerElement}</S.Header>
      <S.Content>{contentElement}</S.Content>
    </S.WidgetSection>
  );
};
